import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createVNode as _createVNode, createCommentVNode as _createCommentVNode, vShow as _vShow, withDirectives as _withDirectives, normalizeClass as _normalizeClass, TransitionGroup as _TransitionGroup, withCtx as _withCtx, Teleport as _Teleport, createBlock as _createBlock } from "vue"

const _hoisted_1 = { id: "app" }
const _hoisted_2 = { class: "p-0 d-flex flex-column container-fluid" }
const _hoisted_3 = { class: "row g-0" }
const _hoisted_4 = { class: "col" }
const _hoisted_5 = { class: "navbar sticky-top navbar-dark bg-dark navbar-expand-lg px-3" }
const _hoisted_6 = {
  href: "#",
  target: "_self",
  class: "navbar-brand"
}
const _hoisted_7 = /*#__PURE__*/_createElementVNode("button", {
  type: "button",
  class: "navbar-toggler collapsed",
  style: {"overflow-anchor":"none"},
  "data-bs-toggle": "collapse",
  "data-bs-target": "#nav-collapse2"
}, [
  /*#__PURE__*/_createElementVNode("span", { class: "navbar-toggler-icon" })
], -1)
const _hoisted_8 = {
  id: "nav-collapse2",
  class: "navbar-collapse collapse"
}
const _hoisted_9 = { class: "navbar-nav ms-auto" }
const _hoisted_10 = { class: "nav-item b-nav-dropdown dropdown" }
const _hoisted_11 = {
  href: "#",
  target: "_self",
  class: "nav-link dropdown-toggle",
  "data-bs-toggle": "dropdown"
}
const _hoisted_12 = {
  tabindex: "-1",
  class: "dropdown-menu dropdown-menu-end"
}
const _hoisted_13 = { class: "text-uppercase" }
const _hoisted_14 = ["onClick"]
const _hoisted_15 = {
  key: 0,
  class: "row flex-grow-1 overflow-hidden g-0 align-items-stretch"
}
const _hoisted_16 = { class: "col-md-3 mh-100 p-1" }
const _hoisted_17 = { class: "col-md-6 mh-100 p-1" }
const _hoisted_18 = { class: "col-md-3 mh-100 p-1" }
const _hoisted_19 = {
  key: 1,
  class: "row flex-grow-1 overflow-hidden g-0 align-items-stretch"
}
const _hoisted_20 = { class: "col-12 mh-100 p-1" }
const _hoisted_21 = { class: "row g-0 align-items-stretch" }
const _hoisted_22 = { class: "col-12" }
const _hoisted_23 = { key: 0 }
const _hoisted_24 = {
  tabindex: "-1",
  class: "b-sidebar-outer"
}
const _hoisted_25 = {
  tabindex: "-1",
  class: "b-sidebar shadow bg-transparent text-dark",
  style: {"width":"250px"}
}
const _hoisted_26 = { class: "b-sidebar-body d-flex" }
const _hoisted_27 = {
  tabindex: "-1",
  class: "b-sidebar-outer"
}
const _hoisted_28 = {
  tabindex: "-1",
  class: "b-sidebar shadow b-sidebar-right bg-transparent text-dark",
  style: {"width":"250px"}
}
const _hoisted_29 = { class: "b-sidebar-body d-flex" }
const _hoisted_30 = { class: "me-auto" }
const _hoisted_31 = /*#__PURE__*/_createElementVNode("button", {
  type: "button",
  class: "btn-close",
  "data-bs-dismiss": "toast"
}, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_file_list = _resolveComponent("file-list")!
  const _component_preview_canvas = _resolveComponent("preview-canvas")!
  const _component_filter_list = _resolveComponent("filter-list")!
  const _component_download_form = _resolveComponent("download-form")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("nav", _hoisted_5, [
              _createElementVNode("a", _hoisted_6, [
                _createElementVNode("span", null, "TinyIBP (" + _toDisplayString(_ctx.APP_VERSION) + ")", 1)
              ]),
              _hoisted_7,
              _createElementVNode("div", _hoisted_8, [
                _createElementVNode("ul", _hoisted_9, [
                  _createElementVNode("li", _hoisted_10, [
                    _createElementVNode("a", _hoisted_11, [
                      _createElementVNode("span", null, _toDisplayString(_ctx.t('app.chooselang')), 1)
                    ]),
                    _createElementVNode("ul", _hoisted_12, [
                      _createElementVNode("li", _hoisted_13, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.availableLocales, (lang) => {
                          return (_openBlock(), _createElementBlock("a", {
                            key: lang,
                            href: "#",
                            target: "_self",
                            class: "dropdown-item text-uppercase",
                            onClick: ($event: any) => (_ctx.locale = lang)
                          }, _toDisplayString(lang), 9, _hoisted_14))
                        }), 128))
                      ])
                    ])
                  ])
                ])
              ])
            ])
          ])
        ]),
        (_ctx.$grid.md)
          ? (_openBlock(), _createElementBlock("div", _hoisted_15, [
              _createElementVNode("div", _hoisted_16, [
                _createVNode(_component_file_list)
              ]),
              _createElementVNode("div", _hoisted_17, [
                _createVNode(_component_preview_canvas)
              ]),
              _createElementVNode("div", _hoisted_18, [
                _createVNode(_component_filter_list)
              ])
            ]))
          : (_openBlock(), _createElementBlock("div", _hoisted_19, [
              _createElementVNode("div", _hoisted_20, [
                _createVNode(_component_preview_canvas)
              ])
            ])),
        _createElementVNode("div", _hoisted_21, [
          _createElementVNode("div", _hoisted_22, [
            _createVNode(_component_download_form)
          ])
        ])
      ]),
      (!_ctx.$grid.md)
        ? (_openBlock(), _createElementBlock("div", _hoisted_23, [
            _createElementVNode("button", {
              type: "button",
              class: "btn btn-secondary collapsed position-fixed start-0 top-50",
              style: {"z-index":"99","overflow-anchor":"none"},
              onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.visibleMobileFilePanel = true))
            }, _toDisplayString(_ctx.t('app.filelist.header')), 1),
            _createElementVNode("div", _hoisted_24, [
              _withDirectives(_createElementVNode("div", _hoisted_25, [
                _createElementVNode("div", _hoisted_26, [
                  _createVNode(_component_file_list)
                ])
              ], 512), [
                [_vShow, _ctx.visibleMobileFilePanel]
              ]),
              _withDirectives(_createElementVNode("div", {
                class: "b-sidebar-backdrop bg-dark",
                onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.visibleMobileFilePanel = false))
              }, null, 512), [
                [_vShow, _ctx.visibleMobileFilePanel]
              ])
            ]),
            _createElementVNode("button", {
              type: "button",
              class: "btn btn-secondary collapsed position-fixed end-0 top-50",
              style: {"z-index":"99","overflow-anchor":"none"},
              onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.visibleMobileFilterPanel = true))
            }, _toDisplayString(_ctx.t('app.filterlist.header')), 1),
            _createElementVNode("div", _hoisted_27, [
              _withDirectives(_createElementVNode("div", _hoisted_28, [
                _createElementVNode("div", _hoisted_29, [
                  _createVNode(_component_filter_list)
                ])
              ], 512), [
                [_vShow, _ctx.visibleMobileFilterPanel]
              ]),
              _withDirectives(_createElementVNode("div", {
                class: "b-sidebar-backdrop bg-dark",
                onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.visibleMobileFilterPanel = false))
              }, null, 512), [
                [_vShow, _ctx.visibleMobileFilterPanel]
              ])
            ])
          ]))
        : _createCommentVNode("", true)
    ]),
    (_openBlock(), _createBlock(_Teleport, { to: "#toast-container" }, [
      _createVNode(_TransitionGroup, { name: "toast" }, {
        default: _withCtx(() => [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.toastList, ([symbol, toast]) => {
            return (_openBlock(), _createElementBlock("div", {
              key: symbol,
              class: "toast show"
            }, [
              _createElementVNode("div", {
                class: _normalizeClass(
            `toast-header bg-${toast.type} bg-opacity-25 text-dark text-opacity-75`
          )
              }, [
                _createElementVNode("strong", _hoisted_30, _toDisplayString(toast.title), 1),
                _hoisted_31
              ], 2),
              _createElementVNode("div", {
                class: _normalizeClass(
            `toast-body bg-${toast.type} bg-opacity-25 text-dark text-opacity-75`
          )
              }, _toDisplayString(toast.text), 3)
            ]))
          }), 128))
        ]),
        _: 1
      })
    ]))
  ], 64))
}